import LoadingButton from "@mui/lab/LoadingButton";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { useTranslation } from "../../../hooks/useTranslation";
import {
  BaseRecord,
  CreateResponse,
  useCustomMutation,
  useModal,
} from "@refinedev/core";
import React from "react";

type ActionButtonProps = {
  title: string;
  description: string;
  icon: React.ReactNode;
  endpoint: string;
  values: object;
  method?: "post" | "delete";
  successMessage?: string;
  onSuccess?: (_data: CreateResponse<BaseRecord>) => void;
};

export const ActionButton = (props: ActionButtonProps) => {
  const {
    title,
    description,
    icon,
    endpoint,
    successMessage,
    values,
    onSuccess,
    method = "post",
  } = props;

  const { show, close, visible } = useModal();
  const { translateWithoutPrefix } = useTranslation();

  const { mutate, isLoading } = useCustomMutation();

  const handleConfirm = () => {
    mutate(
      {
        url: endpoint,
        method: method,
        values: values,
        successNotification: successMessage
          ? () => {
              return {
                message: successMessage,
                type: "success",
              };
            }
          : undefined,
      },
      {
        onSuccess: (data) => {
          onSuccess?.(data);
          close();
        },
      },
    );
  };

  return (
    <>
      <ListItemButton onClick={show}>
        <ListItemIcon>{icon}</ListItemIcon>
        <ListItemText primary={title} />
      </ListItemButton>
      <Dialog open={visible} onClose={isLoading ? undefined : close}>
        <DialogTitle> {title}</DialogTitle>
        <DialogContent>
          <DialogContentText> {description}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={close} disabled={isLoading}>
            {translateWithoutPrefix("buttons.cancel")}
          </Button>
          <LoadingButton onClick={handleConfirm} autoFocus loading={isLoading}>
            {translateWithoutPrefix("common.confirm")}
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </>
  );
};
